export default __webpack_public_path__ + "static/media/Youtube.fb028200.svg";